import strings from '../config/lang.json';

const StringResolver = (str, fallback) => {
    const lang = document.documentElement.lang;

    if (!strings[str] || (strings[str] === undefined) || !strings[str][lang] || (strings[str][lang] === undefined)) return fallback || "[Felaktig sträng]"

    return (
        strings[str][lang]
    );
};

export {StringResolver};